import styled from 'styled-components'

const StyledState = styled.div`
  
`

export default StyledState
